import { authFetch } from "../authFetch";
import TestType from './../newTestPrep/pages/testtypes/TestType';

   export const getPackagesByTestType = async (testType) => {
      try {
        const res = await authFetch(
          `package/packages-by-testtype/${testType}`,
        );

   

        const data = await res.json();
        return data;
      } catch (err) {
        console.error(err);
      }
    };